// extracted by mini-css-extract-plugin
export default {"section":"hqQBOYeefvirz9SuA6a_","pulse":"OGGW6WolIiEHPZe3iWSw"};